var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image_url)?_c('p',{class:_vm.classes,attrs:{"id":"cast-icon-circle"}},[(_vm.image_url)?_c('img',{staticClass:"ml-2",attrs:{"width":_vm.width,"height":_vm.height,"src":_vm._GetImagePath(_vm.image_url)}}):_vm._e()]):_c('p',{staticClass:"noImage ml-2"},[_vm._v("\n  "+_vm._s(_vm.firstWord)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090bdd18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/CastIcon.vue
// module id = null
// module chunks = 